<template>
  <ul
    v-if="
      handleAddToOrder ||
      handleChangeOrderStatus ||
      handleEdit ||
      handleArchive ||
      handleRestore ||
      handleShare ||
      handleDelete ||
      handleRemoveDatafilecopies ||
      handleFreeDiskSpace ||
      handleUnlink
    "
    class="batchactions"
  >
    <li v-if="handleAddToOrder">
      <IconButton
        icon="fa-solid fa-shopping-cart"
        tooltip="Add selected items to order"
        :disabled="disabled"
        :colorful="!disabled"
        @click="handleAddToOrder"
      />
    </li>
    <li v-if="handleChangeOrderStatus">
      <IconButton
        icon="fa-solid fa-check-double"
        tooltip="Change order status of selected items"
        :disabled="disabled"
        :colorful="!disabled"
        @click="handleChangeOrderStatus"
      />
    </li>
    <li v-if="handleEdit">
      <IconButton
        icon="fa-solid fa-edit"
        tooltip="Batch edit selected items"
        :disabled="disabled"
        :colorful="!disabled"
        @click="handleEdit"
      />
    </li>
    <li v-if="handleShare">
      <IconButton
        icon="fa-solid fa-share-alt"
        tooltip="Share selected items"
        :disabled="disabled"
        :colorful="!disabled"
        @click="handleShare"
      />
    </li>
    <li v-if="handleCopy">
      <IconButton
        icon="fa-solid fa-cloud-arrow-up"
        tooltip="Copy datasets"
        :disabled="disabled"
        :colorful="!disabled"
        @click="handleCopy"
      />
    </li>
    <li v-if="handleArchive || (handleRestore && handleRestore.function)">
      <IconButton
        icon="fa-solid fa-archive"
        :disabled="disabled"
        :colorful="!disabled"
        align="end"
      >
        <template #dropdown>
          <a
            v-if="handleArchive"
            class="dd-item"
            :class="{ 'is-disabled': disabled || !handleArchive }"
            tabindex="0"
            @click="!disabled && handleArchive()"
            @keyup.enter="!disabled && handleArchive()"
          >
            <span class="icon">
              <i class="fa-solid fa-archive" />
            </span>
            Archive items
          </a>
          <a
            v-if="handleRestore && handleRestore.function"
            v-tooltip="handleRestore?.tooltip"
            class="dd-item"
            :class="{ 'is-disabled': disabled || handleRestore.disabled }"
            tabindex="0"
            @click="!disabled && handleRestore && handleRestore.function()"
            @keyup.enter="
              !disabled && handleRestore && handleRestore.function()
            "
          >
            <span class="icon">
              <i class="fa-solid fa-box-open" />
            </span>
            {{ handleRestore && handleRestore.name }}
          </a>
        </template>
      </IconButton>
    </li>
    <li v-if="handleDelete">
      <IconButton
        icon="fa-solid fa-trash"
        tooltip="Delete selected items"
        color="danger"
        :disabled="disabled"
        :colorful="!disabled"
        @click="handleDelete"
      />
    </li>
    <li v-if="handleUnlink">
      <IconButton
        icon="fa-solid fa-link-slash"
        tooltip="Unlink selected items"
        color="danger"
        :disabled="disabled"
        :colorful="!disabled"
        @click="handleUnlink"
      />
    </li>
    <li v-if="handleFreeDiskSpace">
      <IconButton
        icon="fa-solid fa-broom"
        tooltip="Free Disk Space"
        color="danger"
        :disabled="disabled"
        :colorful="!disabled"
        @click="handleFreeDiskSpace"
      />
    </li>
    <li v-if="handleRemoveDatafilecopies">
      <IconButton
        icon="fa-solid fa-broom"
        tooltip="Free Disk Space"
        color="danger"
        :disabled="disabled"
        :colorful="!disabled"
        @click="handleRemoveDatafilecopies"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'BatchActions',
  props: {
    disabled: Boolean,
    handleAddToOrder: {
      type: Function,
      default: null,
    },
    handleArchive: {
      type: Function,
      default: null,
    },
    handleChangeOrderStatus: {
      type: Function,
      default: null,
    },
    handleCopy: {
      type: Function,
      default: null,
    },
    handleDelete: {
      type: Function,
      default: null,
    },
    handleUnlink: {
      type: Function,
      default: null,
    },
    handleFreeDiskSpace: {
      type: Function,
      default: null,
    },
    handleEdit: {
      type: Function,
      default: null,
    },
    handleRemoveDatafilecopies: {
      type: Function,
      default: null,
    },
    handleRestore: {
      type: Object,
      default: () => ({
        tooltip: undefined,
        disabled: false,
        name: 'Restore items',
        function: null,
      }),
    },
    handleShare: {
      type: Function,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
ul.batchactions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.1rem;

  &:empty {
    display: none;
  }
}
</style>
